module.exports = __webpack_public_path__ + "static/media/cledbel.8a4fe6dc.png";